@if (company(); as company) {
  <div class="company-container">
    <div class="company-details-header">
      <span class="company-name">{{ company.name }}</span>
      <div class="company-details-actions">
        <ng-container *appHasRole>
          @if (displayLya()) {
            <button
              tiime-button
              icon
              large
              color="primary"
              tiimeTooltip="Envoyer le dossier vers LYA"
              (click)="sendToLya()"
            >
              <img class="lya-icon" src="assets/lya.png" alt="Logo Lya" />
            </button>
          }
          @if (!company.isCopy) {
            <app-apps-access-button [companyId]="company.id" large></app-apps-access-button>
          }
        </ng-container>
        @if (insideCompany()) {
          <button
            tiime-button
            icon
            large
            color="primary"
            tiimeTooltip="Paramétrer le dossier"
            (click)="navigateToParameters()"
          >
            <mat-icon inline="true" svgIcon="icon-parameter"></mat-icon>
          </button>
        }
      </div>
    </div>
    <span class="company-infos">{{ company | companyInfosLabel: (taxRegimes$ | async) }}</span>
    <app-company-status
      [initializationInProgress]="company.initializationInProgress"
      [mission]="company.mission"
      [withIcon]="false"
      [withLabel]="true"
    ></app-company-status>
    <div tiimeProperties>
      <app-address-property
        tiimeIconProperty
        [street]="company?.street"
        [postalCode]="company?.postalCode"
        [city]="company?.city"
        breakLine="false"
      ></app-address-property>
    </div>
    <div class="company-details-separator"></div>
    <div class="company-details-line">
      <span class="company-details-line-title">Siret :</span>
      <div class="row">
        <span class="italic" tiimeFallbackText>
          {{ company.siret | mask: siretMask }}
        </span>
      </div>
    </div>
    @if (displayUsers()) {
      <div class="company-details-line">
        <span class="company-details-line-title">Contacts :</span>
        @if (users(); as users) {
          @if (users.length) {
            <app-company-users-contacts [contacts]="users" showSuffix="true"></app-company-users-contacts>
          } @else {
            <span class="italic" tiimeFallbackText></span>
          }
        } @else {
          <mat-progress-spinner diameter="12" color="primary" mode="indeterminate"></mat-progress-spinner>
        }
      </div>
    }
    <div class="company-details-separator"></div>
    <div class="company-details-line">
      <span class="company-details-line-title">Régime de TVA :</span>
      <span class="italic" tiimeFallbackText>
        @if (company.vatSystem?.code) {
          {{ company.vatSystem.code | codeAndLabel: (vatSystems$ | async) : false }}
        }
      </span>
    </div>
    <div class="company-details-line">
      <span class="company-details-line-title">Régime d'imposition :</span>
      <span class="italic" tiimeFallbackText>
        @if (company.taxRegime) {
          {{ company.taxRegime | taxRegimeLabel: (taxRegimes$ | async) : false }}
        }
      </span>
    </div>
    <div class="company-details-separator"></div>
    <div class="company-details-line">
      <span class="company-details-line-title">Groupe :</span>
      <span class="italic" tiimeFallbackText>
        {{ company.businessUnit?.name }}
      </span>
    </div>
    @if (displayContributors()) {
      <div class="company-details-line contributors">
        <span class="company-details-line-title">Intervenants :</span>
        @if (companyContributors(); as companyContributors) {
          @if (companyContributors.length) {
            <app-company-contributors-contacts
              [contacts]="companyContributors"
              [contributorJobs]="contributorJobs()"
              showPrefix="true"
              displayOthersOnClick="true"
            ></app-company-contributors-contacts>
          } @else {
            <span class="italic" tiimeFallbackText></span>
          }
        } @else {
          <mat-progress-spinner diameter="12" color="primary" mode="indeterminate"></mat-progress-spinner>
        }
      </div>
    }
    <div class="company-details-actions bottom-actions">
      @if (insideCompany()) {
        <button class="action-btn" tiime-button strocked color="primary" (click)="openExonerationZonesDialog()">
          Zones exonération
        </button>
      }
      @if (company.siret || insideCompany()) {
        <button class="action-btn" tiime-button strocked color="primary" [matMenuTriggerFor]="dropdownMenu">
          Liens
          <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
        </button>
        <mat-menu class="company-links-menu" #dropdownMenu="matMenu" yPosition="below" xPosition="before">
          @if (company.siret) {
            <div mat-menu-item (click)="openPappers()">
              <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
              Pappers
            </div>
            <div mat-menu-item (click)="openInfogreffe()">
              <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
              Infogreffe
            </div>
          }
          @if (insideCompany()) {
            @for (externalLink of externalLinks(); track i; let i = $index) {
              <div [class.border-top-separator]="i === 0" mat-menu-item (click)="openLink(externalLink)">
                <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
                <span [tiimeTooltip]="externalLink.name" tooltipHideWithoutEllipsis>{{ externalLink.name }}</span>
                <div class="menu-actions">
                  <button
                    tiime-button
                    icon
                    color="primary"
                    tiimeTooltip="Modifier"
                    (click)="$event.stopPropagation(); openUpdateExternalLinkDialog(externalLink)"
                  >
                    <mat-icon fontSet="fontastic" fontIcon="icon-ic-modify"></mat-icon>
                  </button>
                  <button
                    tiime-button
                    icon
                    color="primary"
                    tiimeTooltip="Supprimer"
                    (click)="$event.stopPropagation(); openDeleteExternalLinkDialog(externalLink, i)"
                  >
                    <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
                  </button>
                </div>
              </div>
            }
            <div mat-menu-item (click)="openCreateExternalLinkDialog()">
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-add-1"></mat-icon>
              Ajouter un lien
            </div>
          }
        </mat-menu>
      }
    </div>
  </div>
  @if (displayContracts()) {
    <div class="contracts-container">
      <app-contracts-container
        [contracts]="contracts()"
        [canCreateContract]="false"
        (updateContract)="updateContract($event)"
        (changeContractStatus)="changeContractStatus($event)"
      ></app-contracts-container>
    </div>
  }
} @else {
  <mat-progress-spinner diameter="16" color="primary" mode="indeterminate"></mat-progress-spinner>
}
